export default __webpack_public_path__ + "static/media/conexopluswhite.61d90d14.png";